import * as Sentry from "@sentry/react"
import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { FallbackErrorPage } from "@/app/error"
import { Router } from "@/app/router"
import "@/css/index.css"
import { store } from "@/store"

const root = createRoot(document.getElementById("root") as HTMLElement)

// Clear the stale-chunk reload flag on successful app boot.
// See error.tsx for the reload-on-chunk-error logic.
sessionStorage.removeItem("chunk-reload")

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  console.info("sentry error catching enabled")
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    sendDefaultPii: false,
  })
}

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackErrorPage />} showDialog>
      <Provider store={store}>
        <Router />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
